import React from 'react';
import { Text } from 'view/atoms/Text';
import * as S from './Ellipsis.styles';

export const Ellipsis = () => (
  <S.Ellipsis>
    <Text kind='button' color='gray2'>
      ...
    </Text>
  </S.Ellipsis>
);
